import { createAction } from '@reduxjs/toolkit';
import { StoreVivoTypes } from '../reducers/VivoStoreReducer';

export const setEmployee = createAction(StoreVivoTypes.SET_EMPLOYEE);
export const setStore = createAction(StoreVivoTypes.SET_STORE);

export default {
  setEmployee, setStore,
};
